import React, { useEffect, useRef, useState } from "react";
import styles from "./productMgmt.module.scss";
import { Add, Numbers, UploadFile } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import { GenCustomTable } from "../../components/customComponents/genCustomTable/GenCustomTable";
import {
  Avatar,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Switch,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import SearchInput from "../../components/uiComponents/searchInput/SearchInput";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import OutlinedButton from "../../components/customComponents/outlinedButton/OutlinedButton";
import StatusCard from "../../components/uiComponents/statusCard/StatusCard";
import { connect, useDispatch } from "react-redux";
import {
  getAllCategory,
  getAllProduct,
  getProductByIdResponse,
  updateProduct,
} from "../../store/actions";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
const columns = [
  {
    id: 1,
    label: "S.NO",
    minWidth: 120,
    align: "center",
  },
  {
    id: 2,
    label: "Image",
    minWidth: 170,
    align: "center",
  },

  {
    id: 4,
    label: "Product Name",
    minWidth: 170,
    align: "center",
  },
  {
    id: 5,
    label: "₹ Price",
    minWidth: 170,
    align: "center",
  },
  {
    id: 7,
    label: "Status",
    minWidth: 170,
    align: "center",
  },
  {
    id: 6,
    label: "Action",
    minWidth: 170,
    align: "center",
  },
];

const ProductMgmt = ({ products = [], product }) => {
  const [filteredData, setFilteredData] = useState([]);
  const [searched, setSearched] = useState("");
  const [selected, setSelected] = useState(0);
  const [values, setValues] = useState({});
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewSize, setPreviewSize] = useState(null);
  const [productList, setProductList] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getAllCategory());
    dispatch(getAllProduct());

    const pro = products?.filter((item) => item?.status === 1 && item?.active === true);
    setProductList(pro);
  }, [product]);

  console.log("ProductMgmt", products);

  const handleEdit = (item = {}, type) => {
    dispatch(getProductByIdResponse(item));
    navigate(
      `/products/${type === "edit" ? "addproductDetails" : "productdetails"}`
    );
  };
  const getUrl = (item) => {
    setPreviewUrl(item?.imageUrl || "");
    setPreviewSize(null);
  };
  const handleImageLoad = (event) => {
    const { naturalWidth, naturalHeight } = event.target;
    const maxWidth = window.innerWidth * 0.9;
    const maxHeight = window.innerHeight * 0.9;
    const aspectRatio = naturalWidth / naturalHeight || 1;

    let width = naturalWidth;
    let height = naturalHeight;

    if (width > maxWidth) {
      width = maxWidth;
      height = width / aspectRatio;
    }
    if (height > maxHeight) {
      height = maxHeight;
      width = height * aspectRatio;
    }

    setPreviewSize({
      width,
      height,
    });
  };
  const getStructuredRows = (data = []) => {
    const structuredRows = data?.map((item, idx) => ({
      id: item?.id,
      rColumns: [
        idx + 1,
        <div className={styles.imgtable}>
          <Button
            variant="outlined"
            classes={{ outlined: styles.ovalButtonOutImg }}
            disableRipple
            disableElevation
            onClick={() => getUrl(item)}
          >
            View
          </Button>
        </div>,
        <Button
          variant="outlined"
          className={styles.ovalButtonOut}
          disableRipple
          disableElevation
          onClick={() => handleEdit(item, "view")}
        >
          {item?.name || "NA"}
        </Button>,
        `₹ ${item?.price}`,
        <Button
          variant="contained"
          // onClick={() =>
          //   dispatch(
          //     updateProduct({
          //       payload: { ...item, status: item?.staus === 1 ? 0 : 1 },
          //       callback: {
          //         success: () => dispatch(getAllProduct()),
          //       },
          //     })
          //   )
          // }
          classes={{
            contained:
              item?.status === 1 ? styles.ovalButton0 : styles.ovalButton1,
          }}
        >
          {item?.status === 1 ? "Active" : "Disabled"}
        </Button>,
        <div
          className={styles.imgtable}
          onClick={() => handleEdit(item, "edit")}
        >
          <EditIcon color="primary" />
          EDIT
        </div>,
        // <Switch
        //   checked={item?.active}
        //   color="success"
        //   // onChange={handleChange}
        //   slotProps={{ input: { "aria-label": "controlled" } }}
        // />,
      ],
    }));

    return structuredRows;
  };
  const getData = (input, data) => {
    const dataFilter = data?.filter((item) =>
      item?.name?.toLowerCase().includes(input?.toLowerCase())
    );
    if (dataFilter?.length > 0) {
      setFilteredData(dataFilter);
    } else {
      setFilteredData(null);
    }
  };

  const handleSearch = (value) => {
    setSearched(value);
    if (value.trim() === "") {
      setFilteredData([]);
    } else {
      const filtered = products.filter((item) =>
        item?.name?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredData(filtered);
    }
  };

  const handleSaveChanges = () => {};

  const handleNavigate = () => {
    dispatch(getProductByIdResponse(null));
    navigate("/products/addproductDetails");
  };

  return (
    <div className={styles.container}>
      {/* <StatusCard
        leftContent="PRODUCTS" // or any icon/component
      /> */}
      <div className={styles.wrapper}>
        <div className={styles.topWrapper}>
          <div className={styles.top}></div>
          <div className={styles.search}>
            {/* <SearchInput
              placeholder="Search product name"
              onSearch={handleSearch}
            /> */}
            {/* <Button
              variant="outlined"
              startIcon={<FilterAltOutlinedIcon />}
              className={styles.filterButton}
            >
              Filter
            </Button> */}
            <CustomButton
              title={"Add"}
              txtClr={"#FFFFFF"}
              background={"black"}
              width={"141px"}
              height={"48px"}
              borderRadius={"12px"}
              onClick={() => handleNavigate()}
            />
          </div>
        </div>
        {/* Image preview modal overlay */}
        <Dialog
          open={!!previewUrl}
          onClose={() => {
            setPreviewUrl("");
            setPreviewSize(null);
          }}
          maxWidth={false}
          PaperProps={{
            className: styles.previewPaper,
            sx: {
              borderRadius: "12px",
              width: previewSize ? `${previewSize.width}px` : "auto",
              height: previewSize ? `${previewSize.height}px` : "auto",
              maxWidth: "90vw",
              maxHeight: "90vh",
            },
          }}
        >
          <DialogContent classes={{ root: styles.previewContainer }}>
            <IconButton
              className={styles.previewClose}
              size="small"
              onClick={() => {
                setPreviewUrl("");
                setPreviewSize(null);
              }}
            >
              <CloseIcon />
            </IconButton>
            {previewUrl && (
              <img
                src={previewUrl}
                alt="Image Preview"
                onLoad={handleImageLoad}
                className={styles.previewImage}
              />
            )}
          </DialogContent>
        </Dialog>
        <div className={styles.bottom}>
          <GenCustomTable
            columns={columns}
            rows={getStructuredRows(searched.trim() ? filteredData : productList)}
          />
        </div>
      </div>
    </div>
  );
};
const mapStateToProps = (state, props) => {
  return {
    products: state.product?.products,
    product: state.product?.product,
  };
};

export default connect(mapStateToProps, null)(ProductMgmt);
